module.exports = __webpack_public_path__ + "img/zyzxfw.7c621261.png";